import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["style", "className"];
import React from 'react';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import Icons from '@rexlabs/icons';
import { useSelect } from '../../hooks/use-select';
var defaultStyles = StyleSheet({
  interactive: {
    cursor: 'pointer'
  }
});
var Search = Icons.Search,
    CrossSmall = Icons.CrossSmall,
    ChevronUp = Icons.ChevronUp;
export function Suffix(_ref) {
  var style = _ref.style,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var s = useStyles(defaultStyles);

  var _useSelect = useSelect(),
      multi = _useSelect.multi,
      searchable = _useSelect.searchable,
      deselectable = _useSelect.deselectable,
      inputValue = _useSelect.inputValue,
      selectedItem = _useSelect.selectedItem,
      setInputValue = _useSelect.setInputValue,
      reset = _useSelect.reset;

  if (inputValue.length > 0 || !multi && deselectable && selectedItem) {
    return /*#__PURE__*/React.createElement(CrossSmall, _extends({}, s.with('interactive')({
      style: style,
      className: className
    }), props, {
      onClick: function onClick() {
        setInputValue('');

        if (deselectable) {
          reset();
        }
      }
    }));
  }

  return searchable ? /*#__PURE__*/React.createElement(Search, _extends({}, props, {
    style: style,
    className: className
  })) : /*#__PURE__*/React.createElement(ChevronUp, _extends({}, props, {
    style: style,
    className: className
  }));
}